export default {
  getAdvs (params) {
    return new Promise((resolve, reject) => {
      axios.get('/api/advs', {
        params:params
      })
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    })
  },
  getHeadlinesList (params) {
    return new Promise((resolve, reject) => {
      axios.get('/api/home/index-headlines', {
        params:params
      })
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    })
  },
  getHotNewsList(params) {
    return new Promise((resolve, reject) => {
      axios.get('/api/home/index-news', {
        params:params
      })
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    })
  },
  getPositionList(params) {
    return new Promise((resolve, reject) => {
      axios.get('/api/home/index-position', {
        params:params
      })
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    })
  },
  getHomeRecommend(params) {
    return new Promise((resolve, reject) => {
      axios.get('/api/home/index-new-recommend', {
        params:params
      })
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    })
  },
  getHomeList(params) {
    return new Promise((resolve, reject) => {
      axios.get('/api/home/index-new-lists', {
        params:params
      })
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    })
  },
  getBbsList (params) {
    return new Promise((resolve, reject) => {
      axios.get('/api/bbs/cards', {
        params:params
      })
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    })
  },
  getArticleList(params) {
    return new Promise((resolve, reject) => {
      axios.get('/api/archive/lists', {
        params:params
      })
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    })
  },
  getSliders(params) {
    return new Promise((resolve, reject) => {
      axios.get('/api/home/sliders', {
        params:params
      })
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    })
  },
  getChannel(params) {
    return new Promise((resolve, reject) => {
      axios.get('/api/archive/channel',{
        params:params
      })
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    })
  },
  getShow(id,params){
    return new Promise((resolve, reject) => {
      axios.get('/api/archive/' + id,{
        params:params
      })
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    })
  },
  getRecommends(id){
    return new Promise((resolve, reject) => {
      axios.get('/api/archive/' + id + '/recommends')
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    })
  },
  getCommentList(id,params){
    return new Promise((resolve, reject) => {
      axios.get('/api/archive/' + id + '/comments',{
        params:params
      })
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    })
  },
  getBbsShow(id){
    return new Promise((resolve, reject) => {
      axios.get('/api/bbs/card/' + id)
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    })
  },
  getBbsCommentList(id,params){
    return new Promise((resolve, reject) => {
      axios.get('/api/bbs/card/' + id + '/comments',{
        params:params
      })
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    })
  },
  getCode(params){
    return new Promise((resolve, reject) => {
      axios.post('/api/sms/code',params)
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    })
  },
  getLogin(params){
    return new Promise((resolve, reject) => {
      axios.post('/api/user/login',params)
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    })
  },
  getGiftlist(id){
    return new Promise((resolve, reject) => {
      axios.get('/api/huodong/'+id+'/recruit-prize-list')
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    })
  },
  getUserlist(id){
    return new Promise((resolve, reject) => {
      axios.get('/api/huodong/'+id+'/recruit-prize-user-list')
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    })
  },
  getWinning(id){
    return new Promise((resolve, reject) => {
      axios.get('/api/huodong/'+id+'/recruit-prize-user-extract')
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    })
  },
  getWinnerlist(id){
    return new Promise((resolve, reject) => {
      axios.get('/api/huodong/'+id+'/recruit-prize-user-record')
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    })
  },
  getLiveList(params){
    return new Promise((resolve, reject) => {
      axios.get('/api/live/list',{
        params:params
      })
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    })
  },
  getLiveInfo(id){
    return new Promise((resolve, reject) => {
      axios.get('/api/live/'+id)
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    })
  },
  getLiveStatus(id){
    return new Promise((resolve, reject) => {
      axios.get('/api/live/status/'+id)
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    })
  },
  getLiveComments(id){
    return new Promise((resolve, reject) => {
      axios.get('/api/live/'+id+'/comments')
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    })
  },
  scendLiveComments(params){
    return new Promise((resolve, reject) => {
      axios.post('/api/live/comment',params)
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    })
  },
  postArticlePraise(params){
    return new Promise((resolve, reject) => {
      axios.post('/api/archive/praise',params)
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    })
  },
  postArticlePraiseNo(params){
    return new Promise((resolve, reject) => {
      axios.post('/api/archive/praise-no',params)
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    })
  },
  postArticleCollect(params){
    return new Promise((resolve, reject) => {
      axios.post('/api/archive/collect',params)
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    })
  },
  postArticleCommentPraise(params){
    return new Promise((resolve, reject) => {
      axios.post('/api/archive/comment/praise',params)
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    })
  },
  
}


// WEBPACK FOOTER //
// ./src/api/motortime.js